<template>
  <div class="articleCard" @click="essayClick">
    <a class="articleCard-left">
      <img :src="resourceUrl(essayObj.titleImg,'title')">
    </a>
    <div class="articleCard-right">
      <a class="pc_card">{{ essayObj.title }}</a>
      <div class="menu">
        <el-tag class="menu-tag" v-for="(tag,index) in tagList" :key="index" type="success" size="small">{{tag}}</el-tag>
      </div>
      <div class="card_bottom">
        <div class="left">
          <img :src="resourceUrl(essayObj.userAvatar,'avatar')">
          <span class="text">{{ essayObj.nickName }}</span>
          <span class="small">{{ essayObj.createTime }}</span>
        </div>
        <div class="right">
          <i class="iconfont icon-pinglun"><img src="@/static/icon/message.svg"></i>
          <span>{{ essayObj.likeNum }}</span>
          <i class="iconfont icon-pinglun"><img src="@/static/icon/appreciate.svg"></i>
          <span>{{ essayObj.messageNum }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'essayComponent',
  props:{
    essayObj:{
      type:Object,
    }
  },
  data(){
    return{
      tagList:[],
    }
  },
  mounted() {
    if(this.essayObj && this.essayObj.tags){
      this.tagList = this.essayObj.tags.split(',');
    }
  },
  methods:{
    essayClick(){
      this.$emit("click")
    }
  }
}
</script>

<style scoped>

.articleCard {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}

.articleCard:hover .articleCard-left {
  /*width: 60%;*/
}

.articleCard:hover img {
  transform: scale(1.1);
}
.articleCard {
  transition: transform 0.3s ease-in-out; /* 添加过渡效果，使动画更平滑 */
}

.articleCard:hover {
  transform: scale(1.01); /* 当鼠标悬停时，将元素放大到 1.2 倍大小 */
}

.articleCard > a {
  width: 400px;
  height: 200px;
  overflow: hidden;
  transition: all .2s;
}

.articleCard > a img {
  display: block;
  width: 400px;
  height: 200px;
  transition: all .2s;
  border-radius: 5px;
}

.articleCard-right {
  padding: 30px;
  width: 400px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #fff;
  border-radius: 5px;
}

.articleCard-right .pc_card {
  margin-bottom: 20px;
  width: 340px;
  height: 57px;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.4;
  color: #292525;
  overflow: hidden;
  /*必须结合的属性,当内容溢出元素框时发生的事情*/
  text-overflow: ellipsis;
  /*可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
  display: -webkit-box;
  /*必须结合的属性 ，将对象作为弹性伸缩盒子模型显示 。*/
  -webkit-line-clamp: 2;
  /*用来限制在一个块元素显示的文本的行数。*/
  /*必须结合的属性 ，设置或检索伸缩盒对象的子元素的排列方式 。*/
}
.menu{
  text-align: left;
}
.menu-tag{
  margin-right: 10px;
}
</style>
